module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.87c9a7c1.png";